import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  image: string;
  quote: string;
  book: string;
  rating: number;
  delay?: number;
}
export function TestimonialCard({
  name,
  location,
  image,
  quote,
  book,
  rating,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="relative bg-white rounded-2xl p-6 shadow-lg shadow-cyan-500/10 border-2 border-cyan-100 hover:border-cyan-300 transition-all duration-300" data-id="element-121">
      <Quote className="absolute top-4 right-4 h-8 w-8 text-cyan-200" data-id="element-122" />

      <div className="flex items-center gap-4 mb-4" data-id="element-123">
        <img src={image} alt={name} className="h-14 w-14 rounded-full object-cover border-2 border-cyan-300 shadow-md" data-id="element-124" />
        <div data-id="element-125">
          <h4 className="font-bold text-slate-900" data-id="element-126">{name}</h4>
          <p className="text-sm text-slate-600" data-id="element-127">{location}</p>
        </div>
      </div>

      <div className="flex gap-1 mb-3" data-id="element-128">
        {[...Array(rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-cyan-500 text-cyan-500" data-id="element-129" />)}
      </div>

      <p className="text-slate-700 leading-relaxed mb-4 italic" data-id="element-130">"{quote}"</p>

      <div className="pt-4 border-t border-cyan-100" data-id="element-131">
        <p className="text-sm font-semibold text-cyan-700" data-id="element-132">
          Libro: <span className="text-slate-900" data-id="element-133">{book}</span>
        </p>
      </div>
    </motion.div>;
}